export function completarEndereco(rua: string, numero = "", cidade = "", estado = "", cep = ""): string {
    let partesEndereco = [rua];
    if (numero) partesEndereco.push(numero);
    if (cidade) partesEndereco.push(cidade);
    if (estado) partesEndereco.push(estado);
    if (cep) partesEndereco.push("CEP: " + cep);

    let enderecoFormatado = partesEndereco.join(" - ");
    return enderecoFormatado;
}